import React from 'react';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import styles from "../../assets/styles/components/footer.module.scss";
import Const from 'const.json'

const Footer: React.FC = () => {
    return (
        <div className={`${styles.footer} d-flex w-100 align-items-center`} role="contentinfo" >
            <Navbar expand="lg" className="p-0">
                <Nav className="me-auto">
                <ul className='d-flex m-auto'>
                    <li className='d-flex'><Nav.Link href="https://www.mevaker.gov.il/accessibility-statement" target='_blank'>{Const.accessibilityStatement}</Nav.Link></li>
                   </ul>
                </Nav>
            </Navbar>
        </div>
    );
};

export default Footer;